import { getActiveResortId } from '../utils/activeResort'

export const STATION_OVERVIEW_ZOOM = 12

// Le centre vient du site ACTIF, ni de /raster/all-layer-info (derriere le module
// lidar) ni de user.Resort, qui est le site d attache et ramenerait la carte au
// point de depart apres chaque bascule. Site actif introuvable : on ne bouge pas.
export const getActiveResortCenter = () => {
  try {
    const activeId = getActiveResortId()
    if (activeId === null) return null
    const resorts = JSON.parse(localStorage.getItem('user'))?.resorts
    const resort = resorts?.find(entry => Number(entry?.id) === activeId)
    if (!resort) return null
    const lng = Number(resort.longitude)
    const lat = Number(resort.latitude)
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null
    return [lng, lat]
  } catch {
    return null
  }
}

const loadGeoJSONN = async (map, forceCenter = false) => {
  const coords = getActiveResortCenter()
  if (!coords) return

  const [longitude, latitude] = coords

  // if forceCenter is true, always center regardless of current position
  if (forceCenter) {
    map.setCenter(coords)
    map._hasBeenCentered = true
    return
  }

  // checking if map is already centered on the resort location (within ~0.01 degrees)
  // this also prevents unnecessary recentering during initialization while ensuring
  // the map centers correctly when navigating back to home
  const currentCenter = map.getCenter()
  const distanceThreshold = 0.01 // ~1km

  const latDiff = Math.abs(currentCenter.lat - latitude)
  const lngDiff = Math.abs(currentCenter.lng - longitude)

  if (
    !map._hasBeenCentered ||
    latDiff > distanceThreshold ||
    lngDiff > distanceThreshold
  ) {
    map.setCenter(coords)
    map._hasBeenCentered = true
  }
}

// Export a function to force recenter the map
export const forceCenterOnResort = async map => {
  return loadGeoJSONN(map, true)
}

// recenter the map on the resort with the reset of the smart search
export const restoreStationExplorationView = async map => {
  const coords = getActiveResortCenter()
  if (!coords) return

  map.flyTo({
    center: coords,
    zoom: STATION_OVERVIEW_ZOOM,
    duration: 1200,
  })
  map._hasBeenCentered = true
}

export default loadGeoJSONN
